import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        counter: '='
    },
    template: `
        <h3>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h3>
        <ul>
            <li ng-repeat="answer in vm.question.answerOptions">{{ answer }}</li>
        </ul>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/question/text/index.js